function showLastMinuteModal(){
	if(document.getElementById('last-minute-modal-html')){
		GIG.Modal.create($('#last-minute-modal-html').html());
	}
}

window.showLastMinuteModal = showLastMinuteModal
